import { DateRange, RangeOptionType } from '@enter/core';
import { PageLayoutRow, PageLayoutTitle } from 'components';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { DateRangeType, IInjectedRootStore } from 'stores';
import { SettingsButton } from '../settings-button';
import * as S from './page-header.styles';

interface IPageHeaderProps {
    title: string;
    hideDateRange?: boolean;
    children?: React.ReactNode;
}

@inject('rootStore')
@observer
export class PageHeader extends React.Component<IPageHeaderProps> {
    public render(): React.ReactElement {
        return (
            <PageLayoutRow>
                <S.Header>
                    <PageLayoutTitle>{this.props.title}</PageLayoutTitle>
                    {this.showDateRange && (
                        <>
                            {/* <S.WrappedDateRange>
                                <DateRange
                                    selectedOptionType={this.currentDateRangeOption}
                                    startDate={this.currentDateRange[0]}
                                    endDate={this.currentDateRange[1]}
                                    onChange={this.handleDateRangeChange}
                                />
                            </S.WrappedDateRange> */}
                            <S.ChildrenWrapper>{this.props.children}</S.ChildrenWrapper>
                            {/* <S.WrappedDateTypeSelect
                                value={this.currentDateRangeType}
                                onChange={this.handleSelectChange}
                            /> */}
                        </>
                    )}
                    <S.Spacer />
                    <SettingsButton />
                </S.Header>
            </PageLayoutRow>
        );
    }
    private get injected(): IInjectedRootStore {
        return this.props as IPageHeaderProps & IInjectedRootStore;
    }
    private get showDateRange(): boolean {
        return !this.props.hideDateRange;
    }
    private get currentDateRange(): [Date, Date] {
        return this.injected.rootStore.dateRangeStore.dateRange;
    }
    private get currentDateRangeOption(): RangeOptionType {
        return this.injected.rootStore.dateRangeStore.dateRangeOption;
    }
    private get currentDateRangeType(): DateRangeType {
        return this.injected.rootStore.dateRangeStore.dateRangeType;
    }
    private readonly handleDateRangeChange = (dateRange: [Date, Date], option: RangeOptionType): void => {
        this.injected.rootStore.dateRangeStore.setDateRange(dateRange);
        this.injected.rootStore.dateRangeStore.setDateRangeOption(option);
    };
    private readonly handleSelectChange = (type: DateRangeType): void => {
        this.injected.rootStore.dateRangeStore.setDateRangeType(type);
    };
}
